import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const NextSlash: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--forwardSlash')}
    data-icon={icon}
    width="12"
    height="19"
    viewBox="0 0 12 19"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-60.000000, -80.000000)" fill="#AB2434">
        <g transform="translate(17.000000, 63.000000)">
          <polygon points="55 17 53.2554942 17 43 36 44.861827 36" />
        </g>
      </g>
    </g>
  </svg>
);

export default NextSlash;
